// Category and stage: how they look, and how an admin picks them.
//
// Every surface that shows one goes through here, so a stage is the same
// colour on the dashboard, the customer header and the admin table.

import { CATEGORIES, CATEGORY_LABEL, STAGES, STAGE_LABEL } from "./api";
import type { Category, Stage } from "./api";

export function StagePill({ stage }: { stage: Stage | null }) {
  if (!stage) return <span className="pill stg-unset">Unset</span>;
  return <span className={`pill stg-${stage}`}>{STAGE_LABEL[stage]}</span>;
}

/** Quieter than a stage on purpose: a category is a fact about the
    business, not a status anybody is trying to move. */
export function CategoryChip({ category }: { category: Category | null }) {
  if (!category) return null;
  return <span className="cat">{CATEGORY_LABEL[category]}</span>;
}

/** The empty option is "unset", which the API stores as null. */
export function CategorySelect({
  value,
  onChange,
  id,
}: {
  value: Category | null;
  onChange: (v: Category | null) => void;
  id?: string;
}) {
  return (
    <select
      id={id}
      value={value ?? ""}
      onChange={(e) => onChange((e.target.value || null) as Category | null)}
    >
      <option value="">—</option>
      {CATEGORIES.map((c) => (
        <option key={c} value={c}>
          {CATEGORY_LABEL[c]}
        </option>
      ))}
    </select>
  );
}

export function StageSelect({
  value,
  onChange,
  id,
}: {
  value: Stage | null;
  onChange: (v: Stage | null) => void;
  id?: string;
}) {
  return (
    <select
      id={id}
      value={value ?? ""}
      onChange={(e) => onChange((e.target.value || null) as Stage | null)}
    >
      <option value="">—</option>
      {STAGES.map((s) => (
        <option key={s} value={s}>
          {STAGE_LABEL[s]}
        </option>
      ))}
    </select>
  );
}
